    <form [formGroup]="ContentCourses">
        <ng-template matStepLabel>Contenido del Curso</ng-template>
        <fieldset class="col-12">
            <legend>
                <span>Registro</span>
            </legend>
    
            <div class="card">
                <div class="card-body">
                    <div class="form-row">
                        <div class="form-group col-md-9">
                            <label>Modulo</label>
                            <input type="text" class="form-control" formControlName="mod_vc_name">
                        </div>
                        <div class="form-group col-md-2">
                            <label>Orden</label>
                            <input type="text" class="form-control" formControlName="mod_in_order">
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <label>Descripción</label>
                            <textarea class="form-control" formControlName="mod_tx_description"></textarea>
                        </div>
    
                    </div>
                    <div class="row">
                        
                        <div class="form-group col-md-3">
                            <button class="btn btn-badminton btn-block" (click)="Save()">Guardar</button>
                        </div>
                    </div>
                </div>
            </div>
    
        </fieldset>
    
        <fieldset class="col-12">
            <legend>Listado</legend>
            <div class="card card-osiptel-default">
                <div class="card-body">
                    <table mat-table [dataSource]="dataSource" matSort
                        class="mat-elevation-z8 col-12">
                        <ng-container matColumnDef="mod_vc_name">
    
                            <th style="width: 75%;" mat-header-cell mat-sort-header *matHeaderCellDef>Modulo
                            </th>
                            <td mat-cell *matCellDef="let element"> {{element.mod_vc_name}} </td>
                        </ng-container>
                        <ng-container matColumnDef="mod_in_order">
                            <th style="width: 5%;" mat-header-cell mat-sort-header *matHeaderCellDef>Orden
                            </th>
                            <td mat-cell *matCellDef="let element"> {{element.mod_in_order}} </td>
                        </ng-container>
    
                        <ng-container matColumnDef="opcion">
                            <th style="width: 20%;" mat-header-cell *matHeaderCellDef> Opciones</th>
                            <td mat-cell *matCellDef="let element">
                                <a class="pr-2" (click)="Modify(element)" ><i class="fa fa-edit"></i>
                                    Editar</a>
                                <a class="pr-2" (click)="Detele(element.mod_in_id)"><i
                                        class="fa fa-remove"></i> Eliminar</a>
                            </td>
                        </ng-container>
    
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                    <mat-paginator #paginatorDatasource [pageSizeOptions]="[5, 10, 20]"
                        showFirstLastButtons></mat-paginator>
                </div>
            </div>
        </fieldset>
    
        <div>
            <button mat-button matStepperPrevious>Anterior</button>
            <button mat-button matStepperNext (click)="Next()">Siguiente</button>
        </div>
    </form>           



